import Button from "./button/index";
import FileDemo from './file/pages';
import FormLayoutDemo from './formlayout/pages';
import InputDemo from './input/pages';
import MessagesDemo from './message/page';
import OverlayDemo from './overlay/pages';
import PanelDemo from './panel/pages';
import SamplePageEdit from "./sample_page/sample-page-edit";
import SamplePage from "./sample_page/sample-page-list";
import TableDemo from "./table/index";
import TreeDemo from './tree/tree';

const uikitRoutes = [
    { path: "/uikit/button", element: <Button /> },
    { path: "/uikit/formlayout", element: <FormLayoutDemo /> },
    { path: "/uikit/input", element: <InputDemo /> },
    { path: "/uikit/panel", element: <PanelDemo /> },
    { path: "/uikit/overlay", element: <OverlayDemo /> },
    { path: "/uikit/message", element: <MessagesDemo /> },
    { path: "/uikit/file", element: <FileDemo /> },
    { path: "/uikit/tree", element: <TreeDemo /> },
    { path: "/uikit/table", element: <TableDemo /> },
    { path: "/uikit/sample-page", element: <SamplePage /> },
    { path: "/uikit/sample-page-edit", element: <SamplePageEdit /> },
];

export default uikitRoutes;